import imageCompression from 'browser-image-compression';

const url = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME_CLOUDINARY}/image/upload`;

const uploadImage = async (image) => {
    const uploadPreset = process.env.REACT_APP_INITIAL_UPLOAD_PRESET;

    if (!uploadPreset) {
        console.error("Cloudinary upload preset is missing. Please check your .env file.");
        return null;
    }

    let fileToUpload = image;

    // Image Compression Options
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
    };

    try {
        // Compress if it's a File and larger than 1MB
        if (image instanceof File && image.size > 1024 * 1024) {
            fileToUpload = await imageCompression(image, options);
        }

        const formData = new FormData();
        formData.append("file", fileToUpload);
        formData.append("upload_preset", uploadPreset);

        const response = await fetch(url, {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.error?.message || `Cloudinary upload failed: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Error uploading image:", error);
        return null;
    }
};

export default uploadImage;
